import { Actions } from './representantActions';

/**
 * Etat initial
 */
const initialState = {
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selectedCode: ''
    },
    representants: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour le domaine "representant"
 */
const reducer = (namespace)=> (state = initialState, action) => {

    switch (action.type) {

        case `${namespace}/${Actions.FETCH_REPRESENTANTS_REQUEST}`:
            return {
                ...state,
                representants: { ...state.representants, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_REPRESENTANTS_SUCCESS}`:
            return {
                ...state,
                representants: { ...state.representants, items: [...action.items], isLoading: false }
            };
        case `${namespace}/${Actions.FETCH_REPRESENTANTS_FAILURE}`:
            return {
                ...state,
                representants: { ...state.representants, isLoading: false, error: action.error }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_REPRESENTANT_REQUEST}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_REPRESENTANT_SUCCESS}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.representants], isLoading: false }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_REPRESENTANT_FAILURE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        case `${namespace}/${Actions.CLEAR_SUGGESTIONS_REPRESENTANT}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };
        case `${namespace}/${Actions.SET_REPRESENTANT_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selectedCode: action.selectedCode }
            };
        case `${namespace}/${Actions.CLEAR_REPRESENTANT_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selectedCode: '' }
            };
        default:
    }

    return state;
};

export default reducer;